import { fetch } from '../request'
import type { RecentListRequest, RecentType } from '../interface'
import type { IResponse } from '../interface/common'

// 我的最近作品列表-列表
export const getRecentList = (params?: RecentListRequest) => {
  return fetch<IResponse<RecentType[]>>('/youyan/recent_project/', {
    method: 'GET',
    params,
  })
}

// 最近作品-移除展示
export const deleteRecent = (project_ids: number[]) => {
  return fetch('/youyan/recent_project/', {
    method: 'DELETE',
    body: {
      project_ids,
    },
  })
}

// // 最近作品-复制到团队空间
// export const copyToTeam = (project_ids: number[]) => {
//   return fetch('/youyan/recent_project/', {
//     method: 'DELETE',
//     body: {
//       project_ids,
//     },
//   })
// }
